// /admin: sign in. An admin who is already signed in goes straight to Today.
import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import ReCAPTCHA from 'react-google-recaptcha'

import { errorText, login } from '../../api/adminV2'
import { EMAIL_PATTERN, ROLES, SITE_KEY } from '../../utils/constants'
import { startAdminSession, takeSessionMessage } from './session'

import './admin.css'

const AdminSignIn = ({ userRole }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [notice] = useState(() => takeSessionMessage())
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [human, setHuman] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  if (userRole === ROLES.ROLE_ADMIN_USER) {
    return <Navigate to="/admin/today" replace />
  }

  const submit = (e) => {
    e.preventDefault()
    if (busy) return
    if (!EMAIL_PATTERN.test(email.trim())) {
      setError('Enter the email address of an admin account.')
      return
    }
    if (password.length < 6) {
      setError('Enter your password (at least 6 characters).')
      return
    }
    setBusy(true)
    setError('')
    login({ login: email.trim(), password })
      .then((data) => {
        if (!data?.token) throw new Error('No token')
        startAdminSession(dispatch, data.token, email.trim())
        navigate('/admin/today', { replace: true })
      })
      .catch((err) => {
        setBusy(false)
        const status = err?.response?.status
        setError(
          status && status < 500
            ? 'That email and password do not match an admin account.'
            : errorText(err, 'Could not sign in. Please try again.')
        )
      })
  }

  return (
    <div className="adm">
      <div className="a-login">
        <form className="a-login-card" onSubmit={submit} noValidate>
          <div className="a-brand">
            <b>morsel</b>
            <span>admin</span>
          </div>
          <div>
            <h1>Sign in</h1>
            <p className="a-sub">For the Morsel team only.</p>
          </div>
          {notice ? <p className="a-notice">{notice}</p> : null}
          <label>
            Email
            <input
              className="a-input"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            Password
            <input
              className="a-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <div>
            <ReCAPTCHA
              onChange={(value) => setHuman(!!value)}
              onExpired={() => setHuman(false)}
              sitekey={SITE_KEY}
              size="normal"
            />
          </div>
          {error ? (
            <p className="a-error" role="alert">
              {error}
            </p>
          ) : null}
          <div>
            <button
              type="submit"
              className="a-btn a-primary"
              aria-disabled={!human || busy}
              disabled={!human || busy}
            >
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default connect(({ user }) => ({ userRole: user.userRole }))(AdminSignIn)
